export default "__VITE_ASSET__BjXOdrLv__"